export const Footer: React.FC = () => {
  return <div></div>;
};
